<template>
	<div class="header-container">
		<div class="header-container__details">
			<div class="row">
				<UserInfo ref="userInfo" />
			</div>
		</div>
	</div>
</template>

<script>
import UserInfo from '@/components/shared/UserInfo/UserInfo.vue';

export default {
	name: 'Header',
	components: {
		UserInfo,
	},
	data: () => ({
		title: '',
	}),
	mounted() {},
	methods: {},
	watch: {
		$route: {
			handler(route) {
				this.title = route.name;
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'Header.scss';
</style>
